import React, { useEffect, useState, useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useResourceContext } from 'react-admin';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TextField, IconButton, Radio, Button, Paper, Typography, Box
} from '@mui/material';




const OperationPlanInputOld = () => {
  const { control, setValue, getValues } = useFormContext();
  const operationPlans = useWatch({ control, name: 'operation_plan', defaultValue: [] });
  const selectedPlanId = useWatch({ control, name: 'selected_plan_id', defaultValue: null });
  const [selectedPlan, setSelectedPlan] = useState({});

  const [plans, setPlans] = useState(operationPlans);
  const { reset } = useFormContext();
  console.log('OperationPlanInput rendered with operationPlans:', operationPlans);

  const columnConfig = [
    // Round-related fields
    { field: 'id', label: 'رقم السجل ODS', ttype: 'readonly' },
    { field: 'sub_day', label: 'اليوم', ttype: 'readonly' },
    { field: 'rounds', label: 'الرد', ttype: 'readonly' },
    { field: 'allocated_seats', label: 'المسكنين', type: 'readonly' },
    { field: 'reversed_seats', label: 'المشمولين', type: 'readonly' },

    // School-related fields
    { field: 'scname', label: 'أسم المدرسة', ttype: 'readonly' },
    { field: 'ministerial_number', label: 'الرقم الوزاري', ttype: 'readonly' },
    { field: 'school_type', label: 'نوع المدرسة', ttype: 'readonly' },
    { field: 'sector', label: 'المنطقة', ttype: 'readonly' },
    { field: 'administration', label: 'أدارة التعليم', ttype: 'readonly' },
    { field: 'office', label: 'مكتب التعليم', ttype: 'readonly' },
    { field: 'gender', label: 'جنس الطلاب', ttype: 'readonly' },
    { field: 'education_level', label: 'المرحلة', ttype: 'readonly' },

    // Bus-related fields
    { field: 'contract_number', label: 'رقم العقد', ttype: 'readonly' },
    { field: 'opname', label: 'المتعهد', ttype: 'readonly' },
    { field: 'operationnumber', label: 'الرقم التشغيلي', ttype: 'readonly' },
    { field: 'operatortype', label: 'نوع المتعهد', ttype: 'readonly' },
    { field: 'sub_operator', label: 'متعهد الباطن', ttype: 'readonly' },
    { field: 'yearmodel', label: 'سنة الصنع', ttype: 'readonly' },
    { field: 'brand', label: 'الموديل', ttype: 'readonly' },
    { field: 'plateletters', label: 'حروف اللوحة', ttype: 'readonly' },
    { field: 'platenumbers', label: 'أرقام اللوحة', ttype: 'readonly' },
    { field: 'capacity', label: 'سعة الركاب', ttype: 'readonly' },
    { field: 'serial_number', label: 'الرقم التسلسلى للحافلة', ttype: 'readonly' },
    { field: 'deviceimei', label: 'رقم جهاز التتبع', ttype: 'readonly' },
    { field: 'operation_card_expiration_date', label: 'تاريخ انتهاء بطاقة التشغيل', ttype: 'readonly' },

    // Driver-related fields
    { field: 'name', label: 'أسم السائق', ttype: 'readonly' },
    { field: 'nid_number', label: 'رقم الهوية', ttype: 'readonly' },
    { field: 'nationalitie', label: 'الجنسية', ttype: 'readonly' },
    { field: 'mobileno', label: 'رقم الجوال', ttype: 'readonly' },
    { field: 'driver_license_type', label: 'نوع الرخصة', ttype: 'readonly' },
    { field: 'license_expiration_date', label: 'تاريخ انتهاء الرخصة', ttype: 'readonly' },
    { field: 'driving_card_end_date', label: 'تاريخ انتهاء بطاقة القيادة', ttype: 'readonly' },
    { field: 'last_gps_signal', label: 'تاريخ أخر اشارة تتبع', ttype: 'readonly' },


    // Commented-out fields (Optional for future use)
    // { field: 'contract_id', label: 'معرف العقد', ttype: 'readonly' },
    // { field: 'operator_id', label: 'المعرف المتعهد', ttype: 'readonly' },
    // { field: 'school_count_move', label: 'المدارس المتحركة', type: 'readonly' },
    // { field: 'assigned_students_move', label: 'الطلاب المسندين (متحرك)', type: 'readonly' },
    // { field: 'school_count_nomove', label: 'المدارس الثابتة', type: 'readonly' },
    // { field: 'assigned_students_nomove', label: 'الطلاب المسندين (ثابت)', type: 'readonly' },
  ];



  useEffect(() => {

    setPlans(operationPlans); // Sync with form state whenever operation_plan changes
  }, [operationPlans]);


  useEffect(() => {







  }, [selectedPlan, setValue]); // `setValue` in the dependencies makes sure it's only called when needed





  const handleSelectPlan = (id) => {
    // setValue('selected_plan_id', id); // Store selected plan ID in form state


    const selectedPlan = plans.find((plan) => plan.id === id);
    setSelectedPlan(selectedPlan); // Sync with form state whenever operation_plan changes



    setValue('selected_plan_id', selectedPlan.id);
    setValue('serial_number', selectedPlan.serial_number);
    setValue('operational_number', selectedPlan.operationnumber);
    const capacity = parseInt(selectedPlan.capacity, 10); // Ensure it's an integer
    setValue('num_of_seats', selectedPlan.capacity);
    setValue('school_id', selectedPlan.ministerial_number, { shouldDirty: true, shouldValidate: true, shouldTouch: true });




    if (!isNaN(capacity) && capacity >= 16) {
      setValue('transport_type', 'vehicle');
    } else {
      setValue('transport_type', 'bus');
    }


    if (selectedPlan.brand) {
      const parts = selectedPlan.brand.split(" -- ").map(part => part.trim());

      setValue('manufacturer_name', parts[0]); // Always set the first part as brand
      setValue('vehicle_model', parts[1] || ""); // If the second part doesn't exist, set an empty string
    }
    setValue('education_area_id', selectedPlan.sector_id, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('education_level', selectedPlan.education_level, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('make_year', selectedPlan.yearmodel, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('gender', selectedPlan.gender, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('vendor_id', selectedPlan.operator_id, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('contract_type', selectedPlan.operatortype, { shouldDirty: true, shouldValidate: true, shouldTouch: true });

    //

    if (selectedPlan.school_type == 'غير حركي' || selectedPlan.school_type == 'حركي' || selectedPlan.school_type == 'حركي وغير حركي') {

      setValue('disability_type', selectedPlan.school_type, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
      setValue('service_type', 'تربية خاصة', { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    }

    else if (selectedPlan.school_type == 'تعليم أهلي') {
      setValue('disability_type', 'لا ينطبق', { shouldDirty: true, shouldValidate: true, shouldTouch: true });
      setValue('service_type', 'تعليم أهلي', { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    }

    else {
      setValue('disability_type', 'لا ينطبق', { shouldDirty: true, shouldValidate: true, shouldTouch: true });
      setValue('service_type', 'تعليم عام', { shouldDirty: true, shouldValidate: true, shouldTouch: true });

    }





    selectedPlan.plateletters = selectedPlan.plateletters.replace(/هـ/g, "ه");



    setValue('plate_number', selectedPlan.platenumbers + ' ' + selectedPlan.plateletters, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('contract_number', selectedPlan.contract_number, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('opname', selectedPlan.opname, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('operator', selectedPlan.operator, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('sub_operator', selectedPlan.sub_operator, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('yearmodel', selectedPlan.yearmodel, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('brand', selectedPlan.brand, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('capacity', selectedPlan.capacity, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('device_imei', selectedPlan.deviceimei, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('operation_card_expiration_date', selectedPlan.operation_card_expiration_date, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('is_sub_contractor', selectedPlan.operatortype === 'رئيسي' ? false : true, { shouldDirty: true, shouldValidate: true, shouldTouch: true });



    setValue('driver_name', selectedPlan.name, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('driver_nid', selectedPlan.nid_number, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('driver_nationality', selectedPlan.nationalitie, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('driver_dob_gregorian', selectedPlan.birth_date, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('driver_dob_hijri', selectedPlan.hijri_birth_date, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('driver_age', selectedPlan.age, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('driver_license_expiry_date', selectedPlan.license_expiration_date, { shouldDirty: true, shouldValidate: true, shouldTouch: true });



    if (selectedPlan.driver_license_type == "رخصة قيادة نقبل ثقيل") {
      selectedPlan.driver_license_type = "رخصة قيادة نقل ثقيل";
    }
    setValue('driver_license_type', selectedPlan.driver_license_type, { shouldDirty: true, shouldValidate: true, shouldTouch: true });


    setTimeout(() => {
      setValue('education_zone_id', selectedPlan.administration_id, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
      setValue('contract_id', selectedPlan.contract_id, { shouldDirty: true, shouldValidate: true, shouldTouch: true });

    }, 0);





    setValue('is_ods', 'correct', { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('driver_is_ods', 'correct', { shouldDirty: true, shouldValidate: true, shouldTouch: true });




  };

  return (
    <>

      {plans && plans.length > 0 ? (

        <Box sx={{ width: '95vw', maxWidth: '95vw', overflow: 'auto', maxHeight: '400px' }}>

          <TableContainer
            component={Paper}
            sx={{
              width: 'max-content', // Forces table to expand horizontally within the scrollable container
              minWidth: 1500,
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ maxHeight: '50px', height: '50px', whiteSpace: 'nowrap' }}></TableCell>

                  {columnConfig.map((col) => (
                    <TableCell
                      key={col.field}
                      sx={{
                        maxHeight: '50px',
                        height: '50px',
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                        width: 'auto', // Allows stretching
                        minWidth: '100px', // Ensures it doesn’t collapse
                      }}
                    >
                      {col.label}
                    </TableCell>
                  ))}

                </TableRow>
              </TableHead>
              <TableBody>
                {plans.map((plan) => (
                  <TableRow key={plan.id}>
                    <TableCell>
                      <Radio
                        checked={selectedPlanId === plan.id}
                        onChange={() => handleSelectPlan(plan.id)}
                      />
                    </TableCell>


                    {columnConfig.map((col) => (
                      <TableCell key={col.field} sx={{
                        maxHeight: '50px',
                        height: '50px',
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                        width: 'auto', // Allows stretching
                        minWidth: '100px', // Ensures it doesn’t collapse
                      }}>
                        <span>{plan[col.field] ? plan[col.field] : "--"}</span>
                      </TableCell>
                    ))}



                    {/*   <TableCell>
        <IconButton onClick={() => handleDeletePlan(plan.id)}>
          <Delete />
        </IconButton>
      </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>

            </Table>
            {/*       <Button onClick={handleAddPlan} startIcon={<Add />} variant="contained" style={{ marginTop: '1em' }}>
        Add Plan
      </Button> */}
          </TableContainer>
        </Box>

      ) : (
        <div style={{ textAlign: 'center', padding: '20px', fontSize: '16px', color: 'gray' }}>
          لا يوجد خطة تشغيلية للحافلة فى النظام بعد
        </div>
      )}
    </>
  );
};


const OperationPlanInput = () => {
  const { control, setValue, getValues } = useFormContext();
  const operationPlans = useWatch({ control, name: 'operation_plan', defaultValue: [] });
  const selectedPlanId = useWatch({ control, name: 'selected_plan_id', defaultValue: null });
  const workflowCategory = useWatch({ control, name: 'workflow_category', defaultValue: null });
  const resource = useResourceContext();
  const [selectedPlan, setSelectedPlan] = useState({});

  const [plans, setPlans] = useState(operationPlans);
  const { reset } = useFormContext();
  console.log('OperationPlanInput rendered with operationPlans:', operationPlans);

  // Check if this is for blacklist_drivers_log resource
  const isBlacklistResource = () => {
    return resource === 'blacklist_drivers_log';
  };

  const columnConfig = [
    // Round-related fields
    { field: 'id', label: 'رقم السجل ODS', ttype: 'readonly' },
    { field: 'sub_day', label: 'اليوم', ttype: 'readonly' },
    { field: 'rounds', label: 'الرد', ttype: 'readonly' },
    { field: 'allocated_seats', label: 'المسكنين', type: 'readonly' },
    { field: 'reversed_seats', label: 'المشمولين', type: 'readonly' },

    // School-related fields
    { field: 'scname', label: 'أسم المدرسة', ttype: 'readonly' },
    { field: 'ministerial_number', label: 'الرقم الوزاري', ttype: 'readonly' },
    { field: 'school_type', label: 'نوع المدرسة', ttype: 'readonly' },
    { field: 'sector', label: 'المنطقة', ttype: 'readonly' },
    { field: 'administration', label: 'أدارة التعليم', ttype: 'readonly' },
    { field: 'office', label: 'مكتب التعليم', ttype: 'readonly' },
    { field: 'gender', label: 'جنس الطلاب', ttype: 'readonly' },
    { field: 'education_level', label: 'المرحلة', ttype: 'readonly' },

    // Bus-related fields
    { field: 'contract_number', label: 'رقم العقد', ttype: 'readonly' },
    { field: 'opname', label: 'المتعهد', ttype: 'readonly' },
    { field: 'operationnumber', label: 'الرقم التشغيلي', ttype: 'readonly' },
    { field: 'operatortype', label: 'نوع المتعهد', ttype: 'readonly' },
    { field: 'sub_operator', label: 'متعهد الباطن', ttype: 'readonly' },
    { field: 'yearmodel', label: 'سنة الصنع', ttype: 'readonly' },
    { field: 'brand', label: 'الموديل', ttype: 'readonly' },
    { field: 'plateletters', label: 'حروف اللوحة', ttype: 'readonly' },
    { field: 'platenumbers', label: 'أرقام اللوحة', ttype: 'readonly' },
    { field: 'capacity', label: 'سعة الركاب', ttype: 'readonly' },
    { field: 'serial_number', label: 'الرقم التسلسلى للحافلة', ttype: 'readonly' },
    { field: 'deviceimei', label: 'رقم جهاز التتبع', ttype: 'readonly' },
    { field: 'operation_card_expiration_date', label: 'تاريخ انتهاء بطاقة التشغيل', ttype: 'readonly' },

    // Driver-related fields
    { field: 'name', label: 'أسم السائق', ttype: 'readonly' },
    { field: 'nid_number', label: 'رقم الهوية', ttype: 'readonly' },
    { field: 'nationalitie', label: 'الجنسية', ttype: 'readonly' },
    { field: 'mobileno', label: 'رقم الجوال', ttype: 'readonly' },
    { field: 'driver_license_type', label: 'نوع الرخصة', ttype: 'readonly' },
    { field: 'license_expiration_date', label: 'تاريخ انتهاء الرخصة', ttype: 'readonly' },
    { field: 'driving_card_end_date', label: 'تاريخ انتهاء بطاقة القيادة', ttype: 'readonly' },
    { field: 'last_gps_signal', label: 'تاريخ أخر اشارة تتبع', ttype: 'readonly' },


    { field: 'escort_name', label: 'أسم المرافق', ttype: 'readonly' },
    { field: 'escort_nid_number', label: 'رقم هوية المرافق', ttype: 'readonly' },
    { field: 'escort_nationalitie', label: 'جنسية المرافق', ttype: 'readonly' },
    { field: 'escort_mobileno', label: 'رقم جوال المرافق', ttype: 'readonly' },


    // Commented-out fields (Optional for future use)
    // { field: 'contract_id', label: 'معرف العقد', ttype: 'readonly' },
    // { field: 'operator_id', label: 'المعرف المتعهد', ttype: 'readonly' },
    // { field: 'school_count_move', label: 'المدارس المتحركة', type: 'readonly' },
    // { field: 'assigned_students_move', label: 'الطلاب المسندين (متحرك)', type: 'readonly' },
    // { field: 'school_count_nomove', label: 'المدارس الثابتة', type: 'readonly' },
    // { field: 'assigned_students_nomove', label: 'الطلاب المسندين (ثابت)', type: 'readonly' },
  ];



  useEffect(() => {

    setPlans(operationPlans); // Sync with form state whenever operation_plan changes
  }, [operationPlans]);


  useEffect(() => {







  }, [selectedPlan, setValue]); // `setValue` in the dependencies makes sure it's only called when needed





  const handleSelectPlan = (id) => {
    // setValue('selected_plan_id', id); // Store selected plan ID in form state


    const selectedPlan = plans.find((plan) => plan.id === id);
    setSelectedPlan(selectedPlan); // Sync with form state whenever operation_plan changes



    setValue('selected_plan_id', selectedPlan.id);
    setValue('serial_number', selectedPlan.serial_number);
    setValue('operational_number', selectedPlan.operationnumber);
    const capacity = parseInt(selectedPlan.capacity, 10); // Ensure it's an integer
    setValue('num_of_seats', selectedPlan.capacity);
    setValue('school_id', selectedPlan.ministerial_number, { shouldDirty: true, shouldValidate: true, shouldTouch: true });




    if (!isNaN(capacity) && capacity >= 16) {
      setValue('transport_type', 'vehicle');
    } else {
      setValue('transport_type', 'bus');
    }


    if (selectedPlan.brand) {
      const parts = selectedPlan.brand.split(" -- ").map(part => part.trim());

      setValue('manufacturer_name', parts[0]); // Always set the first part as brand
      setValue('vehicle_model', parts[1] || ""); // If the second part doesn't exist, set an empty string
    }
    setValue('education_area_id', selectedPlan.sector_id, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('education_level', selectedPlan.education_level, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('make_year', selectedPlan.yearmodel, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('gender', selectedPlan.gender, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('vendor_id', selectedPlan.operator_id, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('contract_type', selectedPlan.operatortype, { shouldDirty: true, shouldValidate: true, shouldTouch: true });

    //

    if (selectedPlan.school_type == 'غير حركي' || selectedPlan.school_type == 'حركي' || selectedPlan.school_type == 'حركي وغير حركي') {

      setValue('disability_type', selectedPlan.school_type, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
      setValue('service_type', 'تربية خاصة', { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    }

    else if (selectedPlan.school_type == 'تعليم أهلي') {
      setValue('disability_type', 'لا ينطبق', { shouldDirty: true, shouldValidate: true, shouldTouch: true });
      setValue('service_type', 'تعليم أهلي', { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    }

    else {
      setValue('disability_type', 'لا ينطبق', { shouldDirty: true, shouldValidate: true, shouldTouch: true });
      setValue('service_type', 'تعليم عام', { shouldDirty: true, shouldValidate: true, shouldTouch: true });

    }





    selectedPlan.plateletters = selectedPlan.plateletters.replace(/هـ/g, "ه");



    setValue('plate_number', selectedPlan.platenumbers + ' ' + selectedPlan.plateletters, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('contract_number', selectedPlan.contract_number, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('opname', selectedPlan.opname, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('operator', selectedPlan.operator, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('sub_operator', selectedPlan.sub_operator, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('yearmodel', selectedPlan.yearmodel, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('brand', selectedPlan.brand, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('capacity', selectedPlan.capacity, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('device_imei', selectedPlan.deviceimei, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('operation_card_expiration_date', selectedPlan.operation_card_expiration_date, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('is_sub_contractor', selectedPlan.operatortype === 'رئيسي' ? false : true, { shouldDirty: true, shouldValidate: true, shouldTouch: true });

    // Handle driver/escort data based on workflow_category for blacklist_drivers_log
    if (isBlacklistResource()) {
      if (workflowCategory === "1") {
        // Driver workflow - use driver fields
        setValue('driver_name', selectedPlan.name, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
        setValue('driver_nid', selectedPlan.nid_number, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
        setValue('driver_nationality', selectedPlan.nationalitie, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
        setValue('driver_dob_gregorian', selectedPlan.birth_date, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
        setValue('driver_dob_hijri', selectedPlan.hijri_birth_date, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
        setValue('driver_age', selectedPlan.age, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
        setValue('driver_license_expiry_date', selectedPlan.license_expiration_date, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
      } else if (workflowCategory === "2") {
        // Escort workflow - use escort fields
        setValue('driver_name', selectedPlan.escort_name, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
        setValue('driver_nid', selectedPlan.escort_nid_number, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
        setValue('driver_nationality', selectedPlan.escort_nationalitie, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
        setValue('driver_dob_gregorian', selectedPlan.escort_birth_date, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
        setValue('driver_dob_hijri', selectedPlan.escort_hijri_birth_date, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
        setValue('driver_age', selectedPlan.escort_age, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
        setValue('driver_license_expiry_date', selectedPlan.license_expiration_date, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
      }
    } else {
      // Keep old logic for other resources
      setValue('driver_name', selectedPlan.name, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
      setValue('driver_nid', selectedPlan.nid_number, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
      setValue('driver_nationality', selectedPlan.nationalitie, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
      setValue('driver_dob_gregorian', selectedPlan.birth_date, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
      setValue('driver_dob_hijri', selectedPlan.hijri_birth_date, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
      setValue('driver_age', selectedPlan.age, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
      setValue('driver_license_expiry_date', selectedPlan.license_expiration_date, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    }



    if (selectedPlan.driver_license_type == "رخصة قيادة نقبل ثقيل") {
      selectedPlan.driver_license_type = "رخصة قيادة نقل ثقيل";
    }
    setValue('driver_license_type', selectedPlan.driver_license_type, { shouldDirty: true, shouldValidate: true, shouldTouch: true });


    setTimeout(() => {
      setValue('education_zone_id', selectedPlan.administration_id, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
      setValue('contract_id', selectedPlan.contract_id, { shouldDirty: true, shouldValidate: true, shouldTouch: true });

    }, 0);





    setValue('is_ods', 'correct', { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    setValue('driver_is_ods', 'correct', { shouldDirty: true, shouldValidate: true, shouldTouch: true });




  };

  return (
    <>

      {plans && plans.length > 0 ? (

        <Box sx={{ width: '95vw', maxWidth: '95vw', overflow: 'auto', maxHeight: '400px' }}>

          <TableContainer
            component={Paper}
            sx={{
              width: 'max-content', // Forces table to expand horizontally within the scrollable container
              minWidth: 1500,
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ maxHeight: '50px', height: '50px', whiteSpace: 'nowrap' }}></TableCell>

                  {columnConfig.map((col) => (
                    <TableCell
                      key={col.field}
                      sx={{
                        maxHeight: '50px',
                        height: '50px',
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                        width: 'auto', // Allows stretching
                        minWidth: '100px', // Ensures it doesn’t collapse
                      }}
                    >
                      {col.label}
                    </TableCell>
                  ))}

                </TableRow>
              </TableHead>
              <TableBody>
                {plans.map((plan) => (
                  <TableRow key={plan.id}>
                    <TableCell>
                      <Radio
                        checked={selectedPlanId === plan.id}
                        onChange={() => handleSelectPlan(plan.id)}
                      />
                    </TableCell>


                    {columnConfig.map((col) => (
                      <TableCell key={col.field} sx={{
                        maxHeight: '50px',
                        height: '50px',
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                        width: 'auto', // Allows stretching
                        minWidth: '100px', // Ensures it doesn’t collapse
                      }}>
                        <span>{plan[col.field] ? plan[col.field] : "--"}</span>
                      </TableCell>
                    ))}



                    {/*   <TableCell>
        <IconButton onClick={() => handleDeletePlan(plan.id)}>
          <Delete />
        </IconButton>
      </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>

            </Table>
            {/*       <Button onClick={handleAddPlan} startIcon={<Add />} variant="contained" style={{ marginTop: '1em' }}>
        Add Plan
      </Button> */}
          </TableContainer>
        </Box>

      ) : (
        <div style={{ textAlign: 'center', padding: '20px', fontSize: '16px', color: 'gray' }}>
          لا يوجد خطة تشغيلية للحافلة فى النظام بعد
        </div>
      )}
    </>
  );
};

export default OperationPlanInput;
